import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bg-background-900 text-foreground-100">
      <div className="container-page py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500">
                <i className="ri-vidicon-line text-xl text-white"></i>
              </div>
              <span className="text-xl font-heading text-white whitespace-nowrap">
                {t("site.name")}
              </span>
            </Link>
            <p className="text-sm text-foreground-300 leading-relaxed">
              {t("site.description")}
            </p>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-4">{t("footer.about")}</h4>
            <ul className="space-y-2.5">
              <li><Link to="/about" className="text-sm text-foreground-300 hover:text-white transition-colors">{t("footer.about")}</Link></li>
              <li><Link to="/article" className="text-sm text-foreground-300 hover:text-white transition-colors">{t("nav.article")}</Link></li>
              <li><Link to="/category" className="text-sm text-foreground-300 hover:text-white transition-colors">{t("nav.category")}</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-4">{t("footer.help")}</h4>
            <ul className="space-y-2.5">
              <li><a href="#" className="text-sm text-foreground-300 hover:text-white transition-colors">{t("footer.help")}</a></li>
              <li><a href="#" className="text-sm text-foreground-300 hover:text-white transition-colors">{t("footer.privacy")}</a></li>
              <li><a href="#" className="text-sm text-foreground-300 hover:text-white transition-colors">{t("footer.terms")}</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-4">{t("footer.contact")}</h4>
            <ul className="space-y-2.5">
              <li className="flex items-center gap-2 text-sm text-foreground-300">
                <i className="ri-mail-line text-accent-500"></i>
                contact@kuaimaovideo.com
              </li>
              <li className="flex items-center gap-2 text-sm text-foreground-300">
                <i className="ri-phone-line text-accent-500"></i>
                400-888-9999
              </li>
              <li className="flex items-center gap-2 text-sm text-foreground-300">
                <i className="ri-map-pin-line text-accent-500"></i>
                北京市朝阳区望京科技园
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-foreground-700/30 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-foreground-400">
            &copy; {new Date().getFullYear()} {t("footer.rights")}
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-foreground-400 hover:text-white transition-colors" aria-label="微博">
              <i className="ri-weibo-line text-lg"></i>
            </a>
            <a href="#" className="text-foreground-400 hover:text-white transition-colors" aria-label="微信">
              <i className="ri-wechat-line text-lg"></i>
            </a>
            <a href="#" className="text-foreground-400 hover:text-white transition-colors" aria-label="抖音">
              <i className="ri-tiktok-line text-lg"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}